module.exports = __webpack_public_path__ + "static/lars-rasmussen-b9469602671fe551c064341cb31ac9ba.png";